import { BaseAdapter } from './base.adapter';
import type { AccountUser, AccountUserRole } from '@/types';
import type { AccountUserResponseDto, CreateAccountUserDto } from '@/types';

// Role number → label. Source of truth: backend account_users.role enum.
// 0=agent, 1=administrator, 2=ai, 3=light_agent, 4=client_restricted, 5=sentinel, 6=readonly_admin
const ROLE_LABELS: Record<number, AccountUserRole> = {
  0: 'agent',
  1: 'administrator',
  2: 'ai',
  3: 'light_agent',
  4: 'client_restricted',
  5: 'sentinel',
  6: 'readonly_admin'
};

/**
 * The shared read-only impersonation user is a member of every account. The team
 * page never shows it; only the super-admin Accounts sheet does, for impersonation.
 */
export const withoutReadonlyAdmin = (users: AccountUser[]): AccountUser[] =>
  users.filter((user) => user.role !== 'readonly_admin');

export class AccountUserAdapter extends BaseAdapter {
  static fromApi(dto: AccountUserResponseDto): AccountUser {
    return {
      id: dto.id,
      accountUserId: dto.accountUserId,
      name: dto.name,
      email: dto.email,
      role: ROLE_LABELS[dto.role] ?? 'agent',
      accountId: dto.accountId,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt
    };
  }

  static fromApiList(dtos: AccountUserResponseDto[]): AccountUser[] {
    return dtos.map((dto) => this.fromApi(dto));
  }

  static toCreateRequest(name: string, email: string, role: number): CreateAccountUserDto {
    return { name, email, role };
  }
}
